import { random } from 'lodash';
import React from 'react';

type Props = {};

const OmniChannelChatHistoriesSessionItemSkeleton: React.FC<Props> = ({}) => {
  return (
    <div className='flex w-full gap-6 px-6 pb-5 pt-4'>
      <div className='skeleton-active relative h-[44px] w-[44px] rounded-full'></div>
      <div className='flex h-[44px] flex-1 flex-col justify-between'>
        <div
          className='skeleton-active h-5 rounded-sm'
          style={{
            width: random(100, 250)
          }}
        ></div>
        <div className='skeleton-active h-5 w-[100px] rounded-sm'></div>
      </div>
    </div>
  );
};
export default OmniChannelChatHistoriesSessionItemSkeleton;
